
// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

const errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf",
}

export default {
	errorMessage
}


// WEBPACK FOOTER //
// ./src/error.js